
































import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
	emits: ["input"],
	props: {
		value: {
			type: Boolean,
			default: true,
		},
	},
	setup(props, context) {
		const val = computed({
			get() {
				return props.value;
			},
			set(v) {
				context.emit("input", v);
			},
		});


		const options = computed(() => {
			return [
				{ value: false, text: "Off" },
				{ value: true, text: "Visible" },
			];
		});

		return {
			val,
			options,
		};
	},
});
